var exports = {
  "az": "Box__XD-wGf",
  "wy": "Box_1__QYlN42",
  "ft": "notOrganization__dDW4zw",
  "kw": "organization__IN760-",
  "pv": "Box_2__xceFRZ",
  "w9": "Box_3__rm-YE5",
  "DZ": "Heading__xgC5Ql",
  "m4": "Octicon__ztND8z",
  "pQ": "Box_4___lgK7w",
  "N_": "Link__LRN71D",
  "bx": "Link_1__Kmftp7",
  "ws": "Box_5__4ztqk6",
  "QH": "Octicon_1__-leeWo",
  "JK": "Octicon_2__Cc0kP_",
};

module.exports = exports;
